import Vue from 'vue'
import App from './App.vue'
import UiComponents from '@/components/ui'
import router from './router'
import store from './store'
import I18n, { setLanguage, t } from '@/i18n'
import { getRuntimePlatform } from '@/utils/runtimePlatform'
import { installMqttSessionExpiry } from '@/utils/mqtt/lifecycle'
import { installAndroidKeyboardAvoidance } from '@/utils/androidKeyboardAvoidance'
import permission from '@/directives/permission'
import { hasPermission } from '@/utils/authorization'
import { installFormDirtyAura } from '@/utils/formDirtyAura'
import '@/permission' // 路由守卫
import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import '@/styles/index.scss'// 全局 css
import '@/styles/list-toolbar.scss'// 列表页工具栏统一尺寸、间距及响应式规则
import '@/styles/tabs.scss'// 页面级 Tab 统一视觉
import '@/styles/myIcon.scss'// 阿里巴巴图标
import 'maplibre-gl/dist/maplibre-gl.css'

// ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/base.css'// fade/zoom 等
import '@/styles/terminal-dropdown.scss'// 终端统一下拉菜单样式（覆盖 Element UI 原生浮层视觉）
import '@/styles/element-feedback.scss'// 终端 Message / MessageBox 视觉适配层
import '@/styles/element-dialog.scss'// 终端 Dialog 视觉适配层
import '@/styles/element-drawer.scss'// 终端 Drawer 视觉适配层
import '@/styles/visual-foundation.scss'// 2.1 全站视觉层级、排版与交互骨架
import '@/styles/control-interactions.scss'// 全站控件 hover / focus / active / 选中状态契约
import '@/styles/selection-controls.scss'
import '@/styles/base-controls.scss'
import '@/styles/composition-controls.scss'
import '@/styles/data-display.scss'
import '@/styles/appearance.scss'// 三套皮肤的材质与交互，沿用统一令牌
import '@/styles/form-control-surfaces.scss'
Vue.use(ElementUI)
Vue.use(I18n)
const syncLanguage = () => {
  setLanguage(store.getters['app/getLanguage'])
  document.title = [router.currentRoute.meta && t(router.currentRoute.meta.title), t(store.state.settings.title)].filter(Boolean).join(' - ')
}
syncLanguage()
store.watch((state, getters) => getters['app/getLanguage'], syncLanguage)
window.addEventListener('languagechange', syncLanguage)
// 全站基础控件统一入口；内部复用 Element UI，不修改底层组件库。
Vue.use(UiComponents)
Vue.directive('permission', permission)
Vue.prototype.$hasPermission = code => hasPermission(store.state.user, code)
installFormDirtyAura()
installAndroidKeyboardAvoidance(router)
installMqttSessionExpiry(store, router)

// Cordova 平台信息可能在 deviceready 后才完整，启动时和就绪后各同步一次。
const syncRuntimePlatform = () => {
  const runtime = getRuntimePlatform()
  store.commit('app/setRuntimePlatform', runtime)
  document.documentElement.classList.toggle('is-cordova-android', runtime.isCordovaAndroid)
}
syncRuntimePlatform()
document.addEventListener('deviceready', () => {
  syncRuntimePlatform()
  syncLanguage()
}, false)

// 设置vue创建时 提示信息  false不提示
Vue.config.productionTip = true

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
